/**
 * @fileoverview Página responsável pelo cadastro de novos acessos ou contas.
 */

import React, { useState, useEffect } from "react";
import qs from 'query-string'

import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import { toast } from "react-toastify";
import { Formik, Form, Field } from "formik";
import usePlans from "../../hooks/usePlans";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import InputMask from 'react-input-mask';
import {
	FormControl,
	InputLabel,
	MenuItem,
	Select,
} from "@material-ui/core";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import logo from "../../assets/logo.png";
import { i18n } from "../../translate/i18n";

import { openApi } from "../../services/api";
import toastError from "../../errors/toastError";
import moment from "moment";
const Copyright = () => {
	return (
		<Typography variant="body2" color="textSecondary" align="center">
			{"Copyright © "}
			<Link color="inherit" href="#">
				PLW
			</Link>{" "}
		   {new Date().getFullYear()}
			{"."}
		</Typography>
	);
};

const useStyles = makeStyles(theme => ({
	root: {
		width: "100vw",
		height: "100vh",
		background: theme.palette.type === 'dark'
			? 'linear-gradient(135deg, #000000 0%, #0a0e27 50%, #16213e 100%)'
			: '#ffffff',
		backgroundRepeat: "no-repeat",
		backgroundSize: "100% 100%",
		backgroundPosition: "center",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		textAlign: "center",
		position: "relative",
		overflow: "auto",
		padding: theme.spacing(2, 0),
		'&::before': theme.palette.type === 'dark' ? {
			content: '""',
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			background: 'radial-gradient(circle at 20% 50%, rgba(91, 124, 255, 0.15) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(120, 40, 200, 0.15) 0%, transparent 50%)',
			pointerEvents: 'none',
		} : {}
	},
	container: {
		position: 'relative',
		zIndex: 1,
	},
	paper: {
		background: theme.palette.type === 'dark'
			? '#1A1A1A'
			: '#ffffff',
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		padding: "40px",
		borderRadius: "24px",
		border: theme.palette.type === 'dark'
			? '1px solid rgba(91, 124, 255, 0.2)'
			: '1px solid #e0e0e0',
		boxShadow: theme.palette.type === 'dark'
			? '0 20px 60px 0 rgba(0, 0, 0, 0.5), 0 0 80px 0 rgba(91, 124, 255, 0.1)'
			: '0 4px 20px rgba(0, 0, 0, 0.08)',
		transition: 'all 0.3s ease',
		marginTop: theme.spacing(2),
		marginBottom: theme.spacing(2),
		'&:hover': {
			transform: 'translateY(-2px)',
			boxShadow: theme.palette.type === 'dark'
				? '0 25px 70px 0 rgba(0, 0, 0, 0.6), 0 0 100px 0 rgba(91, 124, 255, 0.15)'
				: '0 8px 30px rgba(0, 0, 0, 0.12)',
		}
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: "100%",
		marginTop: theme.spacing(2),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
		background: theme.palette.type === 'dark'
			? 'linear-gradient(135deg, #5b7cff 0%, #7828c8 100%)'
			: '#5b7cff',
		color: '#ffffff',
		fontWeight: 600,
		fontSize: '1rem',
		padding: '12px',
		borderRadius: '12px',
		textTransform: 'none',
		boxShadow: theme.palette.type === 'dark'
			? '0 4px 20px rgba(91, 124, 255, 0.4)'
			: '0 2px 8px rgba(91, 124, 255, 0.3)',
		transition: 'all 0.3s ease',
		'&:hover': {
			background: theme.palette.type === 'dark'
				? 'linear-gradient(135deg, #7828c8 0%, #5b7cff 100%)'
				: '#4a6ae8',
			boxShadow: theme.palette.type === 'dark'
				? '0 6px 25px rgba(91, 124, 255, 0.5)'
				: '0 4px 12px rgba(91, 124, 255, 0.4)',
			transform: 'translateY(-1px)',
		}
	},
	textField: {
		'& .MuiOutlinedInput-root': {
			borderRadius: '12px',
			backgroundColor: theme.palette.type === 'dark'
				? 'rgba(255, 255, 255, 0.05)'
				: 'rgba(0, 0, 0, 0.02)',
			transition: 'all 0.3s ease',
			'& fieldset': {
				borderColor: theme.palette.type === 'dark'
					? 'rgba(255, 255, 255, 0.1)'
					: 'rgba(0, 0, 0, 0.1)',
				transition: 'all 0.3s ease',
			},
			'&:hover fieldset': {
				borderColor: theme.palette.type === 'dark'
					? 'rgba(91, 124, 255, 0.5)'
					: 'rgba(102, 126, 234, 0.5)',
			},
			'&.Mui-focused fieldset': {
				borderColor: theme.palette.type === 'dark'
					? '#5b7cff'
					: '#667eea',
				borderWidth: '2px',
			},
			'&.Mui-focused': {
				backgroundColor: theme.palette.type === 'dark'
					? 'rgba(91, 124, 255, 0.08)'
					: 'rgba(102, 126, 234, 0.08)',
			}
		},
		'& .MuiInputLabel-outlined': {
			color: theme.palette.type === 'dark'
				? 'rgba(255, 255, 255, 0.7)'
				: 'rgba(0, 0, 0, 0.6)',
			'&.Mui-focused': {
				color: theme.palette.type === 'dark'
					? '#5b7cff'
					: '#667eea',
			}
		}
	},
	selectField: {
		borderRadius: '12px',
		backgroundColor: theme.palette.type === 'dark'
			? 'rgba(255, 255, 255, 0.05)'
			: 'rgba(0, 0, 0, 0.02)',
		'& .MuiOutlinedInput-notchedOutline': {
			borderColor: theme.palette.type === 'dark'
				? 'rgba(255, 255, 255, 0.1)'
				: 'rgba(0, 0, 0, 0.1)',
			borderRadius: '12px',
		},
		'&:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: theme.palette.type === 'dark'
				? 'rgba(91, 124, 255, 0.5)'
				: 'rgba(102, 126, 234, 0.5)',
		},
		'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: theme.palette.type === 'dark'
				? '#5b7cff'
				: '#667eea',
			borderWidth: '2px',
		}
	},
	link: {
		color: theme.palette.type === 'dark'
			? '#5b7cff'
			: '#667eea',
		fontWeight: 600,
		textDecoration: 'none',
		transition: 'all 0.2s ease',
		'&:hover': {
			textDecoration: 'underline',
			color: theme.palette.type === 'dark'
				? '#7828c8'
				: '#764ba2',
		}
	}
}));

const UserSchema = Yup.object().shape({
	name: Yup.string()
		.min(2, i18n.t("signup.formErrors.name.short"))
		.max(50, i18n.t("signup.formErrors.name.long"))
		.required(i18n.t("signup.formErrors.name.required")),
	password: Yup.string().min(5, i18n.t("signup.formErrors.password.short")).max(50, i18n.t("signup.formErrors.password.long")),
	email: Yup.string().email(i18n.t("signup.formErrors.email.invalid")).required(i18n.t("signup.formErrors.email.required")),
});

const SignUp = () => {
	const classes = useStyles();
	const history = useHistory();
	let companyId = null

	const params = qs.parse(window.location.search)
	if (params.companyId !== undefined) {
		companyId = params.companyId
	}

	const initialState = { name: "", email: "", phone: "", password: "", planId: "", };

	const [user] = useState(initialState);
	const handleSignUp = async values => {
		Object.assign(values, { status: "t" });
		Object.assign(values, { campaignsEnabled: true });
		try {
			await openApi.post("/companies/cadastro", values);
			toast.success(i18n.t("signup.toasts.success"));
			history.push("/login");
		} catch (err) {
			if (process.env.NODE_ENV !== 'production') {
				// console.log(err);
			}
			toastError(err);
		}
	};

	const [plans, setPlans] = useState([]);
	const { list: listPlans } = usePlans();

	useEffect(() => {
		async function fetchData() {
			const list = await listPlans();
			setPlans(list);
		}
		fetchData();
	}, []);


	return (
		<div className={classes.root}>
			<Container component="main" maxWidth="xs" className={classes.container}>
				<CssBaseline />
				<div className={classes.paper}>
				<div>
					<center><img style={{ margin: "0 auto", width: "70%" }} src={logo} alt="Whats" /></center>
				</div>
				{/*<Typography component="h1" variant="h5">
					{i18n.t("signup.title")}
				</Typography>*/}
				{/* <form className={classes.form} noValidate onSubmit={handleSignUp}> */}
				<Formik
					initialValues={user}
					enableReinitialize={true}
					validationSchema={UserSchema}
					validateOnChange={false}
					validateOnBlur={true}
					onSubmit={(values, actions) => {
						setTimeout(() => {
							handleSignUp(values);
							actions.setSubmitting(false);
						}, 400);
					}}
				>
					{({ touched, errors, isSubmitting }) => (
						<Form className={classes.form}>
							<Grid container spacing={2}>
								<Grid item xs={12}>
									<Field
										as={TextField}
										className={classes.textField}
										autoComplete="name"
										name="name"
										error={touched.name && Boolean(errors.name)}
										helperText={touched.name && errors.name}
										variant="outlined"
										fullWidth
										id="name"
										label={i18n.t("signup.form.name")}
									/>
								</Grid>

								<Grid item xs={12}>
									<Field
										as={TextField}
										className={classes.textField}
										variant="outlined"
										fullWidth
										id="email"
										label={i18n.t("signup.form.email")}
										name="email"
										error={touched.email && Boolean(errors.email)}
										helperText={touched.email && errors.email}
										autoComplete="email"
										required
									/>
								</Grid>
								
							<Grid item xs={12}>
								<Field
									as={InputMask}
									mask="(99) 99999-9999"
									variant="outlined"
									fullWidth
									id="phone"
									name="phone"
									error={touched.phone && Boolean(errors.phone)}
									helperText={touched.phone && errors.phone}
									autoComplete="phone"
									required
								>
									{({ field }) => (
										<TextField
											{...field}
											className={classes.textField}
											variant="outlined"
											fullWidth
											label={i18n.t("signup.form.phone")}
											inputProps={{ maxLength: 11 }} // Definindo o limite de caracteres
										/>
									)}
								</Field>
							</Grid>
								<Grid item xs={12}>
									<Field
										as={TextField}
										className={classes.textField}
										variant="outlined"
										fullWidth
										name="password"
										error={touched.password && Boolean(errors.password)}
										helperText={touched.password && errors.password}
										label={i18n.t("signup.form.password")}
										type="password"
										id="password"
										autoComplete="current-password"
										required
									/>
								</Grid>
								<Grid item xs={12}>
									<InputLabel htmlFor="plan-selection" style={{
										marginBottom: '8px',
										color: 'inherit'
									}}>Plano</InputLabel>
									<Field
										as={Select}
										className={classes.selectField}
										variant="outlined"
										fullWidth
										id="plan-selection"
										label={i18n.t("signup.form.plan")}
										name="planId"
										required
									>
										{plans.map((plan, key) => (
											<MenuItem key={key} value={plan.id}>
												{plan.name} - {i18n.t("signup.plan.attendant")}: {plan.users} - {i18n.t("signup.plan.whatsapp")}: {plan.connections} - {i18n.t("signup.plan.queues")}: {plan.queues} - R$ {plan.value}
											</MenuItem>
										))}
									</Field>
								</Grid>
							</Grid>
							<Button
								type="submit"
								fullWidth
								variant="contained"
								color="primary"
								className={classes.submit}
							>
								{i18n.t("signup.buttons.submit")}
							</Button>
							<Grid container justify="flex-end">
								<Grid item>
									<Link
										href="#"
										variant="body2"
										component={RouterLink}
										to="/login"
										className={classes.link}
									>
										{i18n.t("signup.buttons.login")}
									</Link>
								</Grid>
							</Grid>
						</Form>
					)}
				</Formik>
			</div>
			</Container>
		</div>
	);
};

export default SignUp;
